import {
  baseThemes,
  TThemes,
} from '@/tenant-data/base';

export const themes: TThemes = { ...baseThemes };

export default themes;
